<header
  class="lightPurple"
  [ngClass]="
    domainurls == 'https://reraconnect.arcise.in/' && !isproductions
      ? 'redAlertBorder'
      : ''
  "
>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        (click)="isCollapsed = !isCollapsed"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i *ngIf="isCollapsed" class="bi bi-list"></i>
        <i *ngIf="!isCollapsed" class="bi bi-x"></i>
      </button>
      <div
        class="collapse navbar-collapse"
        [collapse]="isCollapsed"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav mb-2 mb-lg-0" *ngIf="userDetails?.roleId == 5">
          <li class="nav-item">
            <a
              class="nav-link firstMenu"
              [ngClass]="{ disabled: !userDetails }"
              [routerLink]="DASHBOARD"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              (click)="isCollapsed = !isCollapsed"
              >Home</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              [ngClass]="{ disabled: !userDetails }"
              routerLinkActive="active"
              [routerLink]="NEW_LAUNCH"
              (click)="isCollapsed = !isCollapsed"
              >New Launches</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              [ngClass]="{ disabled: !userDetails }"
              routerLinkActive="active"
              [routerLink]="FOS_VISIT + '/create'"
              (click)="isCollapsed = !isCollapsed"
              >FOS Visit</a
            >
          </li>
        </ul>
        <ul class="navbar-nav mb-2 mb-lg-0" *ngIf="userDetails?.roleId != 5">
          <li class="nav-item">
            <a
              class="nav-link firstMenu"
              [ngClass]="{ disabled: !userDetails }"
              [routerLink]="DASHBOARD"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              (click)="isCollapsed = !isCollapsed"
              >Home</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              [ngClass]="{ disabled: !userDetails }"
              routerLinkActive="active"
              [routerLink]="NEW_LAUNCH"
              (click)="isCollapsed = !isCollapsed"
              >New Launches</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              [ngClass]="{ disabled: !userDetails }"
              routerLinkActive="active"
              [routerLink]="SUPPORT"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="isCollapsed = !isCollapsed"
              >User Support</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              [ngClass]="{ disabled: !userDetails }"
              routerLinkActive="active"
              [routerLink]="HELP_CENTER_ROUTER"
              (click)="isCollapsed = !isCollapsed"
              >Support Chat</a
            >
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link disabled" disabled="true" routerLinkActive="active" routerLink="cc"
              (click)="isCollapsed = !isCollapsed">Insights</a>
          </li> -->

          <li
            class="nav-item"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            <div class="btn-group simpleDrp" dropdown>
              <a
                id="FOS"
                [ngClass]="{ disabled: !userDetails }"
                dropdownToggle
                type="button"
                class="nav-link dropdown-toggle"
              >
                FOS <span class="caret"></span>
              </a>
              <ul
                id="dropdown-basic"
                *dropdownMenu
                class="dropdown-menu"
                role="menu"
                aria-labelledby="FOS"
                (click)="isCollapsed = !isCollapsed"
              >
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    [ngClass]="{ disabled: !userDetails }"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [routerLink]="BROKERSACTIVITY_ROUTER"
                    (click)="isCollapsed = !isCollapsed"
                    >Brokers Activity</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    [ngClass]="{ disabled: !userDetails }"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [routerLink]="USERSUPPORT_ROUTER"
                    (click)="isCollapsed = !isCollapsed"
                    >User Support Report</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    [ngClass]="{ disabled: !userDetails }"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [routerLink]="SUBSCRIPTION_ROUTER"
                    (click)="isCollapsed = !isCollapsed"
                    >Subscription Report</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    [ngClass]="{ disabled: !userDetails }"
                    routerLinkActive="active"
                    [routerLink]="REFERRAL_ROUTER"
                    (click)="isCollapsed = !isCollapsed"
                    >Referral Report</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    [ngClass]="{ disabled: !userDetails }"
                    routerLinkActive="active"
                    [routerLink]="PAYMENT_ROUTER"
                    (click)="isCollapsed = !isCollapsed"
                    >Payment Report</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    [ngClass]="{ disabled: !userDetails }"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [routerLink]="SUBSCRIPTION_ROUTER + '/edit'"
                    (click)="isCollapsed = !isCollapsed"
                    >Edit Plan</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    [ngClass]="{ disabled: !userDetails }"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [routerLink]="SUBSCRIPTION_ROUTER + '/extend'"
                    (click)="isCollapsed = !isCollapsed"
                    >Extend Plan</a
                  >
                </li>

                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    [routerLink]="FOS_VISIT + '/create'"
                    routerLinkActive="active"
                  >
                    FOS Visit</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    [routerLink]="FOS_VISIT + '/list'"
                    routerLinkActive="active"
                  >
                    Call/Visit Report</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    [routerLink]="FOS_VISIT + '/database'"
                    routerLinkActive="active"
                  >
                    Database Report</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    [ngClass]="{ disabled: !userDetails }"
                    routerLinkActive="active"
                    [routerLink]="LOAN_ROUTER"
                    (click)="isCollapsed = !isCollapsed"
                    >Loan</a
                  >
                </li>
              </ul>
            </div>
          </li>
        </ul>

        <h2 class="m-auto">
          <a class="navbar-brand" routerLink="/dashboard">
            <img
              *ngIf="appName"
              src="./assets/images/ezyestLogo.svg"
              width="120px"
              alt="logo"
            />
          </a>
        </h2>

        <div class="d-flex flex-wrap loggedInUser">
          <div class="btn-group" dropdown *ngIf="userDetails">
            <div
              id="button-basic"
              dropdownToggle
              aria-hidden="false"
              type="button"
              class="dropdown-toggle loggedInUserName"
              aria-controls="dropdown-basic"
            >
              <img
                *ngIf="userDetails.profilePic"
                src="{{ userDetails.profilePic }}"
                class="profileImg"
              />
              <i
                *ngIf="!userDetails.profilePic"
                class="bi bi-person-circle"
              ></i>
              {{ userDetails.name }} <span class="caret"></span>
            </div>
            <div *ngIf="userDetails?.roleId == 5">
              <ul
                id="dropdown-basic"
                *dropdownMenu
                class="dropdown-menu"
                role="menu"
                aria-labelledby="button-basic"
              >
                <li role="menuitem">
                  <a class="dropdown-item" routerLink="/" (click)="Logout()"
                    >Logout</a
                  >
                </li>
              </ul>
            </div>
            <div *ngIf="userDetails?.roleId != 5">
              <ul
                id="dropdown-basic"
                *dropdownMenu
                class="dropdown-menu"
                role="menu"
                aria-labelledby="button-basic"
              >
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    routerLink="post-property/bulkupload"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Bulk Inventory Upload</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    routerLink="post-property/approveproperty"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Approve Property</a
                  >
                </li>

                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    routerLink="search-page"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Search Page</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    routerLink="premium-broker"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Broker List</a
                  >
                </li>

                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    routerLink="admin/user-accounts"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >User List</a
                  >
                </li>

                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    routerLink="broker-profile"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [queryParams]="{ id: userDetails.id }"
                    >My Profile</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    routerLink="profile"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Edit Profile</a
                  >
                </li>
                <li role="menuitem">
                  <a
                    class="dropdown-item"
                    routerLink="property/list"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Inventory list</a
                  >
                </li>
                <!-- <li role="menuitem"><a class="dropdown-item" routerLink="a/buy-requirement">Buy Requirement</a></li> -->
                <li style="height: 10px; border-bottom: 1px solid #e8e4e4"></li>
                <li role="menuitem">
                  <a class="dropdown-item" routerLink="/" (click)="Logout()"
                    >Logout</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <button
            *ngIf="userDetails?.roleId != 5"
            class="btn btn-purple"
            [ngClass]="{ disabled: !userDetails }"
            type="button"
            (click)="postPropertyModal(postProperty)"
          >
            Post Inventory
          </button>
          <div
            *ngIf="userDetails?.roleId != 5"
            class="menuBar"
            [ngClass]="{ disabled: !userDetails }"
            (click)="sideNavOpenClose = !sideNavOpenClose"
          >
            <i class="bi bi-list pe-1"></i>
            Menu
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>

<!-- Admin Menu  -->
<div class="modal-backdrop fade show" *ngIf="sideNavOpenClose"></div>
<div
  class="sidebarNav text-muted"
  [ngClass]="sideNavOpenClose ? 'activeSideNav' : ''"
>
  <div class="hmenu__sideMenu">
    <a class="btn btn-purple btnSmall" (click)="postPropertyModal(postProperty)"
      >Post Inventory</a
    >
    <div (click)="sideNavOpenClose = !sideNavOpenClose">
      <i class="bi bi-x"></i>
    </div>
  </div>
  <div class="sddssBody">
    <accordion [isAnimated]="true">
      <accordion-group
        [isOpen]="menu.id === 1"
        *ngFor="let menu of sideMenuArr"
      >
        <div class="heading" accordion-heading>
          <span>{{ menu.menuName }}</span>
        </div>
        <ul class="list-group list-group-flush">
          <li class="caption_strong" *ngFor="let menu of menu?.children">
            <a
              routerLink="{{ menu.routerLink }}"
              [queryParams]="{ Id: menu.id }"
              (click)="sideNavOpenClose = !sideNavOpenClose"
              >{{ menu.menuName }}</a
            >
          </li>
        </ul>
      </accordion-group>
    </accordion>
    <div class="footerSDX">
      <accordion [isAnimated]="true">
        <accordion-group [isOpen]="true">
          <div class="heading" accordion-heading>
            <span>Contact Us</span>
          </div>
          <div class="footerBody">
            <div class="mb-1">
              <strong>Email: </strong>
              <span>{{ "info@ezyest.com" }}</span>
            </div>
            <div class="mb-1">
              <strong>Call: </strong>
              <span> +91 8064526920</span>
            </div>
          </div>
        </accordion-group>
      </accordion>
    </div>
  </div>
</div>

<ng-template #postProperty>
  <app-post-property-pop
    (ClosePopUp)="ClosePopUp($event)"
  ></app-post-property-pop>
</ng-template>
